// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-wrapper[data-v-b88ba2c0]{text-align:center}.error-wrapper p[data-v-b88ba2c0]{color:var(--grey__slate);margin:1em}.error-icon[data-v-b88ba2c0]{font-size:120px;color:var(--grey__slate);margin:.5em}", ""]);
// Exports
module.exports = exports;
